export default __webpack_public_path__ + "static/media/hbs-k-cbb-3.26e54d1e.png";